import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";

const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

const ProgressCircle = (props) => {
  const [offset, setOffset] = useState(0);
  const circleRef = useRef(null);
  const { size, progress, label, strokeWidth, circleOneStroke, circleTwoStroke, showExtraLabel } = props;

  const center = size / 2;
  const radius = size / 2 - strokeWidth / 2;
  const circumference = 2 * Math.PI * radius;

  useEffect(() => {
    if (!isIE11) {
      setOffset(((100 - progress) / 100) * circumference);
      circleRef.current.style = "transition: stroke-dashoffset 850ms ease-in-out";
    }
  }, [setOffset, progress, circumference, offset]);

  return (
    <>
      <svg className="progress-circle" width={size} height={size}>
        <circle className={`progress-circle__bg ${progress === 100 ? "progress-circle__bg--complete" : ""}`} stroke={circleOneStroke} cx={center} cy={center} r={radius} strokeWidth={strokeWidth} />
        <circle className="progress-circle__circle" ref={circleRef} stroke={circleTwoStroke} cx={center} cy={center} r={radius} strokeWidth={strokeWidth} strokeDasharray={circumference} strokeDashoffset={offset || 0} />
        {progress !== 100 ? (
          <text x={`${center}`} y={`${showExtraLabel ? center : center + 4}`} className="progress-circle__text">
            {label}
            {showExtraLabel && (
              <tspan className="progress-circle__text--small " x={`${center}`} y={`${center + 9}`}>
                TASKS
              </tspan>
            )}
          </text>
        ) : (
          <g>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="white" width="16" height="16" x={`${center - 8}`} y={`${center - 8}`}>
              <path d="M503 151L215 439C208 445 200 448 192 448S176 445 169 439L9 279C-3 266 -3 246 9 233L41 201C48 195 56 192 64 192S80 195 87 201L192 307L425 73C432 67 440 64 448 64S464 67 471 73L503 105C515 118 515 138 503 151Z" />
            </svg>
          </g>
        )}
      </svg>
    </>
  );
};

ProgressCircle.propTypes = {
  size: PropTypes.number.isRequired,
  progress: PropTypes.number.isRequired,
  strokeWidth: PropTypes.number.isRequired,
  circleOneStroke: PropTypes.string.isRequired,
  circleTwoStroke: PropTypes.string.isRequired,
};

export default ProgressCircle;
